<template>
  <v-tabs
    class="answer-container mt-2 grey lighten-2"
    v-if="this.JourneyTypes[0].id !== null"
    background-color="grey lighten-3"
    v-model="journeyTabs"
  >
    <v-tabs-slider color="accent"></v-tabs-slider>
    <v-tab
      v-for="journey in journeys"
      :key="journey.id"
      :class="{ 'font-weight-bold': SelectedCustomer.active_journey.id === journey.id }"
      >{{ journey.name }}</v-tab
    >

    <v-tab-item v-for="journey in journeys" :key="journey.id">
      <v-row dense class="grey lighten-2 mt-2">
        <v-col cols="6">
          <v-card class="ml-0">
            <answer-list :groups="journey.question_groups"></answer-list>
          </v-card>
        </v-col>
        <v-col cols="6" v-if="userCanView">
          <comment-list
            :customer="SelectedCustomer"
            class="ml-2"
            v-if="dialler"
            :dialler="dialler"
            :key="SelectedCustomer.id"
          ></comment-list>

          <v-card v-else>
            <product-list
              :exclusions="exclusions"
              :isBankReferral="isBankReferral"
              :journeyId="journey.id"
            ></product-list>
          </v-card>
        </v-col>
      </v-row>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import AnswerList from './AnswerList';
import ProductList from '../Products/ProductList';
import CommentList from '../Comments/CommentList';

export default {
  name: 'answers-container',
  props: ['exclusions', 'isBankReferral', 'dialler'],
  components: { CommentList, AnswerList, ProductList },
  data: () => ({
    journeyTabs: 1
  }),
  computed: {
    ...mapGetters(['JourneyTypes', 'SelectedCustomer', 'UserHasRole']),
    journeys: function() {
      if (_.isNull(this.JourneyTypes[0].id)) {
        return [{ name: 'loading...', id: '123' }];
      }
      const initial = [this.JourneyTypes[0].journeys[0]];
      const current = _.filter(
        this.JourneyTypes[1].journeys,
        journey => journey.id === this.SelectedCustomer.active_journey.id
      );
      let others = _.orderBy(
        _.filter(this.JourneyTypes[1].journeys, journey => journey.id !== this.SelectedCustomer.active_journey.id),
        'name'
      );
      if (this.UserHasRole('Property Broker')) {
        others = _.filter(others, journey => journey.name !== 'Business Funding');
      }
      const product = this.UserHasRole('Broker') ? [] : [this.JourneyTypes[2].journeys[0]];
      return _.uniqBy([...initial, ...current, ...others, ...product], 'id');
    },
    userCanView() {
      return this.UserHasRole('Platform') || this.UserHasRole('Broker') || this.UserHasRole('Property Broker');
    }
  }
};
</script>

<style lang="scss" scoped>
.answer-container {
  height: calc(100vh - 200px);
  max-height: calc(100vh - 200px);
  overflow: hidden;
}
</style>
